module.exports = __webpack_public_path__ + "static/img/__cooking.510d0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__cooking.jpg
// module id = KtXz
// module chunks = 0